const cache: { [key: string]: unknown | undefined } = {};

export const getCachedResult = <T>(key: string) => (cache?.[key] as T) || undefined;
export const setCachedResult = <T>(key: string, value: T) => {
  cache[key] = value;
};

/**
 * Reusing already fired request by attaching to same promise.
 * Usefull if multiple request is fetching from same endpoint, while
 * the first request has not been finished (so no cache exist yet).
 */

export let pendingPromise: { [key: string]: Promise<globalThis.Response> } = {};
export const isPendingPromise = (url: string) => !!pendingPromise[url];
export const setPendingPromise = (url: string, promise: Promise<globalThis.Response>) => {
  pendingPromise = {
    ...pendingPromise,
    [url]: promise,
  };
};
export const clearPendingPromise = (url: string) => {
  delete pendingPromise[url];
};
